<template lang="pug">
  #QRCode.container-width
    .mb-5.text-center(
      v-if="data"
    )
      .p-3
        .mb-2.mt-3
          ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-gray(
            :profileUrl="data.picture_url",
            :style="{ 'width': '120px', 'height': '120px' }",
            :changeProfile="false",
          )
          input.d-none(
            type="file",
            accept="image/*",
            id="imageUpload",
            @change="fileUploadHandler()",
            ref="imageUploadInput"
          )
        p.mb-2 {{ data.chinese_last_name }} {{ data.chinese_first_name }}
      hr.border-primary.border-width-lg.w-100
      .p-3
        small.d-block(style='color: #6c6c6c; font-size:85%') 邀請您成為我的摯友
        vue-qr.mb-3(
          v-if="data",
          style="width: 150px"
          :text="`${ bindSaRouter }?sa_id=${ data.id ? data.id : null }&store_id=${ nowSelectStore ? nowSelectStore.id : null }`"
        )
        p.mb-2
          i.fas.fa-map-marker-alt.mr-2
          span {{ data.stores[0].title }}
        p.mb-0
          i.fas.fa-user.mr-2
          span {{ data.preferred_name }}
</template>

<script>
import { mapState } from 'vuex';
import VueQr from 'vue-qr';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

export default {
  name: 'QRCodeIndex',
  components: {
    ProfilePhotoSticker,
    VueQr
  },
  data() {
    return {
      nowSelectStore: null
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '請稍候，\n載入中',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    // 取得個人資料
    vm.$store.dispatch('sa_qr_code/getProfileHandler')
      .then(() => {
        vm.nowSelectStore = vm.data.stores[0] ? vm.data.stores[0] : null;
        vm.$swal.close();
        vm.$store.commit('toggleLoading', false);
      });
  },
  methods: {
    changeQRCodeHandler(store) {
      const vm = this;
      if (store === vm.nowSelectStore) return;
      vm.nowSelectStore = store;
    }
  },
  computed: {
    ...mapState({
      data: (state) => state.sa_qr_code.data
    }),
    bindSaRouter() {
      if (process.env.NODE_ENV === 'development') {
        return `${process.env.VUE_APP_DOMAIN}:${process.env.VUE_APP_DEV_PORT}/member/bind-sa`;
      }
      return `${process.env.VUE_APP_DOMAIN}/member/bind-sa`;
    }
  }
};
</script>

<style>

</style>
